export default __webpack_public_path__ + "static/media/990.2bf9cbd0.png";